
import React from "react";


import { connect } from "react-redux";

import history from "../../auth/history";
import './Subtransaction.css';
import moment from "moment";
class SubTransactionDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			suTransactionStatus: 'pending'
		}
	}




	componentDidMount() {
	}
	componentWillUnmount() {
	}

	render() {

		return (
			<div class="subtxn">
				<h4>Sub Transactions</h4>

				{
					this.props.response.map(txRsp => (

						<div class={(txRsp.status.toLowerCase() != 'success' && txRsp.status.toLowerCase() != 'failed') ?
							'subtxn-pending' : 'subtxn-' + txRsp.status.toLowerCase()}>
							<div class="row">
								<div class="col-6 col-md-3 col-lg-3 order-md-1">
									<div class="subtxt txnsts">{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
										txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</div>
								</div>

								<div class="col-6 col-md-2 col-lg-2 order-md-4">
									<div class="subtxt subamunt rtxt">₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</div>
								</div>

								<div class="col-12 col-md-4 col-lg-4 order-md-2">
									<div class="subtxt subid">Txn ID: {txRsp.id}</div>
								</div>

								<div class="col-12 col-md-3 col-lg-3 order-md-3">
									{/* <div class="subtxt">{moment(txRsp.createdOn==null?this.props.createdOn:txRsp.createdOn).format('DD-MM-YYYY hh:mm:ss')}</div> */}
									<div class="subtxt">{moment(this.props.createdOn).format('DD-MM-YYYY hh:mm:ss')}</div>
								</div>



							</div>
							<div class="row">
								{txRsp.supplierRsp != '' && txRsp.supplierRsp != null && txRsp.supplierRsp != undefined && txRsp.status.toLowerCase() != 'success' &&
									<div class="col-12">
										<div class="subtxt txnsts">
											{txRsp.supplierRsp.toLowerCase().includes("displaymsg") ?
											txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
												txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "")
												.includes("message") ?
												txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
													txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "")
													.substring(txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
														txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "").indexOf("message"),
														txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
															txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "").length)
												:
												txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
													txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "")
											:
											txRsp.supplierRsp.toLowerCase().includes("message") ?
												txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("message"),
													txRsp.supplierRsp.length).replace("message:", "").replace("message-", "") :
												txRsp.supplierRsp.toLowerCase()}
										</div>
									</div>
								}
							</div>
						</div>


					))

				}



			</div>


		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, createOrderRes, createOrderStatusResponse }
	}) => ({
		errorMessage, loginErrorMessage, phone, createOrderRes, createOrderStatusResponse
	});

export default connect(mapStateToProps, null)(SubTransactionDetails);